export const instagram_url = 'https://www.instagram.com/cpandr/';
export const twitter_url = 'https://twitter.com/CPandRuk/';
export const linkedin_url = 'https://linkedin.com/company/cp-r/';
export const homepage_url = 'https://cpandr.co.uk/';
